/* eslint-disable react/prop-types */
import React from "react";
import './SessionTimeoutModal.css'

const SessionTimeoutModal = ({ show, onLogin }) => {
  if (!show) return null;

  return (
    <div className="session-overlay">
      <div className="session-modal">
        <div className="session-icon">⏰</div>
        <h2>Session Timed Out</h2>
        <p>
          Since you are logged in through another session,
          the current session has been logged out!
          Thank you!
          <br />
          Please log in again to continue.
        </p>
        <div className="session-buttons">
          <button className="login-btn" type="button" onClick={onLogin}>
            Login Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;